// #413: how long a draft day lasts, by the simulator's one estimate
// (daySeconds): the model's generator fits each day to the minutes the
// athlete chose with it. Pure; keep free of React and any UI import.
import { isCellAbsent, parseRepsToken } from "./programEditBuild.js";
import type { SlotDraft } from "./programEdit.js";
import { daySeconds, type TimedDay } from "./programSimulationSets.js";
import type { Exercise } from "./schemas/exercise.js";

const intOf = (v: string | undefined): number | undefined => {
  if (v === undefined || v.trim() === "") return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
};

/** Round `w` of a draft day as daySeconds reads it: the slots on in that
 *  round, each with the sets it has there. */
export const draftDayOf = (slots: ReadonlyArray<SlotDraft>, w: number): TimedDay => ({
  entries: slots.flatMap((slot) => {
    if (slot.inactiveWeeks[w] === true) return [];
    const sets = slot.setRows.flatMap((row) => {
      if (isCellAbsent(row, w)) return [];
      const cell = row.cells[w];
      if (!cell) return [];
      const restSec = intOf(cell.restSec);
      const rest = restSec === undefined ? {} : { restSec };
      const duration = intOf(cell.workDurationSec);
      if (row.workKind === "countdown" && duration !== undefined)
        return [{ targetReps: 0, work: { kind: "countdown" as const, durationSec: duration }, ...rest }];
      if (row.workKind === "countup") return [{ targetReps: 0, work: { kind: "countup" as const }, ...rest }];
      return [{ targetReps: parseRepsToken(cell.reps)?.reps ?? 0, ...rest }];
    });
    return sets.length > 0 ? [{ exerciseId: slot.exerciseId, group: slot.group, sets }] : [];
  }),
});

/** A draft day's seconds: its longest round. */
export const draftDaySeconds = (
  slots: ReadonlyArray<SlotDraft>,
  rounds: number,
  bySlug: ReadonlyMap<string, Exercise>,
): number => {
  let most = 0;
  for (let w = 0; w < rounds; w += 1) most = Math.max(most, daySeconds(draftDayOf(slots, w), bySlug).seconds);
  return most;
};
